<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      scrollable
      width="auto"
    >
      <template v-slot:activator="{ props }">
        <v-btn
          color="primary"
          v-bind="props"
          @click="dialogComputed = true"
        >
        Get Files from SFTP
        </v-btn>
      </template>
      <v-card>
        <v-card-title>Select Files</v-card-title>
        <v-divider></v-divider>
        <v-row class="spacedRow">
      <v-col>
        <v-progress-linear indeterminate v-if="isLoadingData">
        </v-progress-linear>
      </v-col>
    </v-row>
        <v-card-text style="height: 30rem;">
          <v-radio-group
            v-model="selectedFile"
            column
          >
            <template v-for="todo in fileList">
              <v-radio
                v-bind:key="todo"
                :label="todo"
                :value="todo"
              ></v-radio>
            </template>
          </v-radio-group>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="blue-darken-1"
            variant="text"
            @click="dialog = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue-darken-1"
            variant="text"
            @click="previewFile"
          >
            Preview
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <TransformMapperPreviewData
      ref="childComponentRef"
      :isImportedData="true"
      @importDataFromFile="importDataFromFile"
    />
  </v-row>
</template>

<script>
import { mapActions } from 'vuex';
import TransformMapperPreviewData from '@/components/config/TransformMapperPreviewImport.vue';
import { clients } from '@/util/clients/index';

const { backendRest } = clients.direct;

export default {
  components: {
    TransformMapperPreviewData,
  },
  props: {
    pipeline: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    selectedFile: undefined,
    dialog: false,
    fileList: [],
    fileData: {},
    isLoadingData: true,
  }),
  created() {
  },
  computed: {
    dialogComputed: {
      get() {
        return this.dialog;
      },
      set(value) {
        this.dialog = value;
        this.fileList = [];
        this.getListFromSftp();
      },
    },
  },
  methods: {
    ...mapActions([
      'flashError',
    ]),
    async getListFromSftp() {
      let response = {};
      const { sftpType } = this.pipeline.customConfig.importProfile;
      this.isLoadingData = true;
      try {
        if (sftpType != null) {
          response = await backendRest.get(`/sftp/get-import-list?sftpType=${sftpType}`);
        }
      } catch (e) {
        console.error(e);
        this.flashError('Facing issue while fetching file/s list from SFTP');
      }
      this.fileList = (response.data || []).map((r) => r.name);
      this.isLoadingData = false;
    },
    async previewFile() {
      let response = {};
      this.isLoadingData = true;
      const { sftpType } = this.pipeline.customConfig.importProfile;
      if (this.selectedFile && sftpType != null) {
        try {
          response = await backendRest.get(`/sftp/download-file?filePath=${this.selectedFile}&sftpType=${sftpType}`);
        } catch (e) {
          console.error(e);
          this.flashError('Facing issue while downloading file from SFTP');
        }
      }
      this.fileData = response.data || {};
      this.$refs.childComponentRef.previewImportedData(this.pipeline, this.fileData.parsedData || '');
      this.isLoadingData = false;
    },
    importDataFromFile() {
      this.dialog = false;
      const file = new File([this.fileData.parsedData || ''], this.selectedFile);
      this.$emit('importDataFromFile', file);
    },
  },
};
</script>
